import * as S from './styled'

const baseHost = window.env && window.env.baseHost
const isActiveSubmenu = menu => `${baseHost}${menu}` === location.href

const MenuItems = ({ menu, currentMenu }) => {
  const active = menu.name === currentMenu

  const { name, glyph, link, submenu } = menu

  const hasMoreItems = Boolean(submenu?.length)

  return (
    <S.Menu>
      <S.MenuItem href={`${baseHost}${link}`} isActive={active}>
        <S.Glyph className={`glyph glyph-${glyph}`} />
        {name}
      </S.MenuItem>

      {hasMoreItems && (
        <S.Submenu>
          {submenu.map((submenu, id) => (
            <S.MenuItem
              key={id}
              href={`${baseHost}${submenu.link}`}
              isActive={isActiveSubmenu(submenu.link)}
            >
              {submenu.name}
            </S.MenuItem>
          ))}
        </S.Submenu>
      )}
    </S.Menu>
  )
}

export default MenuItems
